import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5 2v2.5m0 14V21m-6.718-2.782L7.55 16.45m9.9-9.9 1.767-1.768M3 11.5h2.5m14 0H22M5.783 4.782 7.55 6.55m9.9 9.9 1.768 1.768M17.5 11.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
  stroke: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }